






























































import { defineComponent, ref, Ref, toRefs } from '@nuxtjs/composition-api'
import { formFieldProps } from '~/constants/form'
import PaidServiceItem from '~/components/car/classifieds/form/fieldsets/fields/handlers/rentals/PaidServiceItem.vue'
import { useClassifiedForm } from '~/compositions/form'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'
import { ciTrash } from '~/icons/source/solid/trash'
import { ciPlus } from '~/icons/source/solid/plus'

interface Discount {
  discount: number
  days: number | undefined
}

export default defineComponent({
  components: { FieldError, PaidServiceItem },
  props: formFieldProps,

  setup(props) {
    const { name } = toRefs(props)
    const discounts = ref([{ days: undefined, discount: 0 }] as Discount[])

    function onValue(v: Ref<any>) {
      if (!v.value || !v.value.length) {
        discounts.value = [{ days: undefined, discount: 0 }]
        return
      }

      discounts.value = [...v.value]
    }
    const { error, debouncedValueChanged } = useClassifiedForm(props, {
      onValue
    })

    const handleInputChange = (i: number, val: string, type: any) => {
      discounts.value[i] = {
        ...discounts.value[i],
        [type]: val ? parseFloat(val) : undefined
      }
      discounts.value = discounts.value.slice()
      handleDiscountChange()
    }

    const handleDiscountChange = () => {
      debouncedValueChanged(name.value, [...discounts.value])
    }

    const addRow = () => {
      discounts.value.push({ days: undefined, discount: 0 })
    }

    const removeRow = (index: number) => {
      discounts.value = discounts.value.filter((_, i) => i !== index)

      if (discounts.value.length === 0) {
        addRow()
      }

      handleDiscountChange()
    }

    const icons = {
      delete: ciTrash,
      plus: ciPlus
    }

    return {
      discounts,
      addRow,
      removeRow,
      error,
      icons,
      handleInputChange,
      handleDiscountChange
    }
  }
})
